import React, { FC } from "react"
import { Button } from "react-bootstrap"

export const AddBtn: FC = () => {
    return (
        <Button className="pt-2">
            <img
                src="/img/plus-symbol-button.png"
                width="25"
                height="25"
                className="d-inline-block align-top"
                alt="plus-symbol"
            />
        </Button>
    )
}